import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class BluetoothPrinterService {
    private printCharacteristic: BluetoothRemoteGATTCharacteristic | null | undefined = null;
    private device: BluetoothDevice | null = null;
    SERVICE = '000018f0-0000-1000-8000-00805f9b34fb';
    WRITE = '00002af1-0000-1000-8000-00805f9b34fb';
    constructor() {}

    async seleccionarImpresoraBluetooth(): Promise<boolean> {
        if (!('bluetooth' in navigator)) {
            console.error('Web Bluetooth API no está disponible en este navegador.');
            return false;
        }
        
        try {
            this.device = await navigator.bluetooth.requestDevice({
                filters: [{ services: [this.SERVICE] }]
            });            
            const server = await this.device.gatt?.connect();
            const service = await server?.getPrimaryService(this.SERVICE);
            this.printCharacteristic = await service?.getCharacteristic(this.WRITE);
            // Listener para desconexión
            this.device.ongattserverdisconnected = () => {
                this.printCharacteristic = null;
                this.device = null;
            };
            return true;
        } catch (error) {
            console.error('Error al seleccionar dispositivo Bluetooth:', error);
            return false;
        }
    }

    get isPrinterConnected(): boolean {
        return this.printCharacteristic !== null;
    }

    get ConnectedDevice(): BluetoothRemoteGATTCharacteristic  | null | undefined {
        return this.printCharacteristic;
    }

    async desconectarImpresora(): Promise<boolean> {
        if (this.device) {
            await this.device.gatt?.disconnect();
            this.device = null;
            this.printCharacteristic = null;
            return true;
        }
        return false;
    }
}